<template>
  <div>
    <div
      style="
        width: 500px;
        text-align: center;
        background-color: #fff;
        position: absolute;
        margin-left: -250px;
        left: 50%;
        top: 40px;
        height: 38px;
      "
    >
      <a-button-group>
        <a-button type="primary" @click="onPrevPage">
          <a-icon type="left" />
        </a-button>
        <a-button type="primary" style="line-height: 32px">
          <a-input-number
            style="
              width: 60px;
              height: 30px;
              margin-right: 10px;
              text-align: center;
            "
            v-model="pageNum"
            :min="min"
            :max="max"
            @change="pageOnChange"
            @blur="pageBlur"
          />
          /
          <span style="margin-left: 10px">{{ pages }}</span>
          <!-- {{ pageNum }} -->
        </a-button>
        <a-button type="primary" @click="onNextPage">
          <a-icon type="right" />
        </a-button>
        <a-button type="primary" @click="iconJian">
          <a-icon type="minus" />
        </a-button>
        <a-button type="primary">
          <a-slider :step="scaleStep" :min="scaleMin" :max="scaleMax" v-model="pdfScale" style="width: 100px; margin: 0" />
        </a-button>
        <a-button type="primary" @click="iconAdd">
          <a-icon type="plus" />
        </a-button>
      </a-button-group>
    </div>
    <div class="pdfContent" :style="{ height: mHeight + 'px', marginTop: '20px' }">
      <!-- <div style="height: 20px"></div> -->
      <canvas id="the-canvas"></canvas>
    </div>
  </div>
</template>
<script>
// import PDF from 'pdfjs-dist'
// PDF.disableWorker = true
const PDF = window.pdfjsLib
export default {
  name: 'Pdf',
  data() {
    return {
      scaleStep: 0.2,
      scaleMin: 0.6,
      scaleMax: 5,
      mwidth: '',
      mHeight: '',
      min: 1,
      max: 1,
      width: 100,
      pdfDoc: null,
      pageNum: 1,
      pages: 0,
      pageRendering: false,
      pageNumPending: null,
      pdfScale: 1.6
    }
  },
  props: {
    pdfUrl: {
      type: String,
      default: ''
    },
    tMax: {
      type: Number,
      default: 0
    }
  },
  watch: {
    pdfUrl: function() {
      const _that = this
      if (_that.pdfUrl) _that.loadFile(_that.pdfUrl)
    },
    tMax: function() {
      this.max = this.tMax
    }
    // pdfScale: function() {
    //   this.queueRenderPage(this.pageNum)
    // },
  },
  methods: {
    pageOnChange(num) {
      if (Number(num) < Number(this.max) && Number(num) > Number(this.min)) {
        this.pageNum = parseInt(num)
      } else {
        this.pageNum = this.min
      }
    },
    pageBlur() {
      if (this.pdfDoc) {
        this.queueRenderPage(Number(this.pageNum))
      }
    },
    onPrevPage() {
      if (this.pageNum <= 1) {
        return
      }
      this.pageNum--
      this.queueRenderPage(this.pageNum)
    },
    onNextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return
      }
      this.pageNum++
      this.queueRenderPage(this.pageNum)
    },
    /*放大PDF文件*/
    iconAdd() {
      console.log(this.pdfScale, this.scaleMax - 0.2)
      if (this.pdfScale <= this.scaleMax - 0.2) {
        this.pdfScale = this.pdfScale + 0.2
      }
      this.renderPage(this.pageNum, this.pdfScale)
    },
    /*缩小PDF文件*/
    iconJian: function() {
      if (this.pdfScale >= this.scaleMin + 0.2) {
        this.pdfScale = this.pdfScale - 0.2
      }
      this.renderPage(this.pageNum, this.pdfScale)
    },
    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num
      } else {
        this.renderPage(num)
      }
    },
    renderPage(num, scale = 1.5) {
      console.log('num', num)
      this.pageRendering = true
      const _that = this
      this.pdfDoc.getPage(num).then(function(page) {
        // var scale = 1.5
        console.log('scale', scale)
        var viewport = page.getViewport({ scale: scale })
        console.log(viewport, 'viewport')
        // Support HiDPI-screens.
        var outputScale = window.devicePixelRatio || 1

        var canvas = document.getElementById('the-canvas')
        var context = canvas.getContext('2d')

        canvas.width = Math.floor(viewport.width * outputScale)
        canvas.height = Math.floor(viewport.height * outputScale)
        canvas.style.width = Math.floor(viewport.width) + 'px'
        canvas.style.height = Math.floor(viewport.height) + 'px'

        var transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null

        var renderContext = {
          canvasContext: context,
          transform: transform,
          viewport: viewport
        }
        var renderTask = page.render(renderContext)

        // debugger
        // // var viewport = page.getViewport({ scale: 1.5, })

        // //var viewport = page.getViewport(screen.availWidth / page.getViewport(1).width)
        // var viewport = page.getViewport(_that.pdfScale)
        // const canvas = document.getElementById('the-canvas')
        // canvas.height = viewport.height
        // canvas.width = viewport.width
        // _that.width = viewport.width

        // // Render PDF page into canvas context
        // var renderContext = {
        //   canvasContext: canvas.getContext('2d'),
        //   viewport: viewport,
        // }
        // var renderTask = page.render(renderContext)

        // Wait for rendering to finish
        renderTask.promise.then(function() {
          _that.pageRendering = false
          if (_that.pageNumPending !== null) {
            // New page rendering is pending
            _that.renderPage(_that.pageNumPending)
            _that.pageNumPending = null
          }
        })
      })
    },
    /*加载PDF文件*/
    loadFile: function(url) {
      const _that = this
      _that.pdfDoc = null
      // let CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/'
      // url = 'data:application/pdf;base64,' + url
      //     const src =  PDF.createLoadingTask({
      //    url: url,
      //    //引入pdf.js字体，templ
      //    cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
      //    cMapPacked: true
      //  })
      PDF.getDocument({
        url: url,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
        cMapPacked: true
      }).promise.then(function(pdf) {
        _that.pdfDoc = pdf
        console.log('pdf', pdf)
        _that.pages = _that.pdfDoc.numPages
        if (!_that.tMax) {
          _that.max = _that.pdfDoc.numPages
        }
        _that.renderPage(_that.min)
      })
    }
  },
  created: function() {
    this.mHeight = document.body.clientHeight * 0.92
    this.loadFile(this.pdfUrl)
  }
}
</script>
<style>
.pdfContent {
  overflow: scroll;
  text-align: center;
}
</style>
